import { createContext, useContext, useState, useCallback } from "react";
import translations from "@/i18n/translations";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem("epidemos-lang") || "pl";
  });

  const changeLanguage = useCallback((lang) => {
    setLanguage(lang);
    localStorage.setItem("epidemos-lang", lang);
  }, []);

  // Funkcja tlumaczenia z notacja kropkowa
  const t = useCallback(
    (key) => {
      const keys = key.split(".");
      let result = translations[language];
      for (const k of keys) {
        if (result && typeof result === "object" && k in result) {
          result = result[k];
        } else {
          return key; // Zwroc klucz jesli brak tlumaczenia
        }
      }
      return typeof result === "string" ? result : key;
    },
    [language]
  );

  return (
    <LanguageContext.Provider value={{ language, setLanguage: changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage musi byc uzyte wewnatrz LanguageProvider");
  }
  return context;
}
